import { render, staticRenderFns } from "./entryConfig.vue?vue&type=template&id=4f4be3bc&scoped=true&"
import script from "./entryConfig.vue?vue&type=script&lang=js&"
export * from "./entryConfig.vue?vue&type=script&lang=js&"
import style0 from "./entryConfig.vue?vue&type=style&index=0&id=4f4be3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4be3bc",
  null
  
)

export default component.exports